"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopup = exports.context = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.context = React.createContext(null);
const usePopup = () => React.useContext(exports.context);
exports.usePopup = usePopup;
